import { Clock, ExternalLink } from "lucide-react";
import featuredRoulette from "../../assets/images/featured-roulette.png";
import featuredSlot from "../../assets/images/featured-slot.png";

function FeaturedProjects() {
  const featuredProjects = [
    {
      title: "Webルーレットアプリ",
      description: "任意の項目を設定可能なWebルーレットアプリです。",
      image: featuredRoulette,
      period: "開発工数：3時間",
      tags: ["Node.js", "React", "Next.js"],
      liveUrl: "https://roulette.cocoit.jp/",
    },
    {
      title: "Webスロットアプリ（ハロウィン風）",
      description:
        "Start/Stopボタンを押すだけのシンプルなWebスロットアプリです。",
      image: featuredSlot,
      period: "開発工数：3時間",
      tags: ["Node.js", "React", "Next.js"],
      liveUrl: "https://slot.cocoit.jp/",
    },
  ];

  return (
    <section
      id="featured-projects"
      className="bg-white px-6 py-16 md:px-12 md:py-24 lg:px-24"
    >
      <div className="fade-in-section mx-auto max-w-7xl">
        <div className="mb-10 space-y-4 text-center md:mb-12">
          <div className="mb-12 text-center md:mb-16">
            <h2 className="mb-4 text-xl font-bold text-gray-900 md:text-2xl">
              個人開発プロジェクト
            </h2>
            <div className="mx-auto h-1 w-20 bg-blue-600"></div>
          </div>
          <p className="mx-auto mt-4 max-w-2xl leading-relaxed text-gray-600">
            AIにすべて任せて"どこまで作れるか"を検証した個人開発プロジェクトです。
            <br />
            モダンなWeb開発のベストプラクティクスを土台に、AIを活用して実装を高速化し、短いサイクルで改善を回しています。
          </p>
        </div>
        <div className="grid gap-6 md:grid-cols-2 md:gap-8 lg:grid-cols-3">
          {featuredProjects.map((project, index) => (
            <div
              key={index}
              className="fade-in-section"
              style={{ transitionDelay: `${index * 60}ms` }}
            >
              <div className="group transform overflow-hidden rounded-2xl bg-white shadow-lg transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl">
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-110"
                    loading="lazy"
                  />
                </div>

                <div className="p-6">
                  <h3 className="mb-2 text-gray-900 transition-colors group-hover:text-blue-600">
                    <a
                      href={project.liveUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2 hover:text-blue-600"
                    >
                      {project.title}
                    </a>
                  </h3>
                  {project.period && (
                    <div className="mb-2 flex items-center gap-2 text-sm text-gray-500">
                      <Clock className="h-4 w-4 text-gray-500" aria-hidden="true" />
                      <span>{project.period}</span>
                    </div>
                  )}
                  <p className="mb-4 line-clamp-3 h-[2.6rem] text-sm text-gray-600">
                    {project.description}
                  </p>

                  <div className="mb-4 flex flex-wrap gap-2">
                    {project.tags.map((tag, tagIndex) => (
                      <span
                        key={tagIndex}
                        className="rounded-lg bg-blue-50 px-3 py-1 text-xs text-blue-700"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                  {project.liveUrl && (
                    <a
                      href={project.liveUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="group/btn mt-4 flex w-full items-center justify-center gap-2 rounded-lg px-4 py-2 text-blue-600 transition-colors hover:bg-blue-50 hover:text-blue-700"
                    >
                      <span className="text-sm">デモはこちら</span>
                      <ExternalLink size={16} />
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FeaturedProjects;
